import React from 'react'
import styles from 'components/Shared/Tabs/Tabs.module.css'
import { AppBar, Tabs as MaterialTabs } from '@material-ui/core'
import StyledTab from 'components/Shared/Tabs/StyledTab/StyledTab'

export default function Tabs ({
  id,
  className,
  tabs,
  selectedTab,
  addNewTab,
  onSelectedTabChange,
  onTabRemove,
  onTabNameChange
}) {
  return (
    <div className={styles.wrapper}>
      <AppBar position="static"
              color="default"
              elevation={0}
              id={id}
              className={className}>
        <MaterialTabs value={selectedTab}
                      className={styles.tabs}
                      indicatorColor="secondary"
                      textColor="inherit"
                      scrollButtons="auto"
                      variant="scrollable"
                      selectionFollowsFocus>
          {tabs.map((tab, index, { length }) => {
            return <StyledTab {...tab}
                              key={tab.id}
                              className={tab.isUpdated ? styles.updateIndicator : ''}
                              showDelete={length > 1 && onTabRemove}
                              showEdit={!!onTabNameChange}
                              onRemove={(tabId) => {
                                onTabRemove(tabId)
                                onSelectedTabChange(Math.max(selectedTab - (index > selectedTab ? 0 : 1), 0))
                              }}
                              alwaysShowIcons={index === selectedTab}
                              onNameChange={onTabNameChange}
                              onClick={() => {
                                onSelectedTabChange(index)
                              }}
            />
          })}
          {addNewTab && <StyledTab className={styles.addNewTab} {...addNewTab}/>}
        </MaterialTabs>
      </AppBar>
      {tabs[selectedTab]?.render()}
    </div>
  )
}
